declare global {
  interface Window {
    ttq?: {
      track(event: string, options?: Record<string, unknown>): void;
      page(): void;
      load(pixelId: string): void;
      loadedPixels: string[];
    };
  }
}

export const loadTikTokSdk = () => {
  if (window.ttq) return false;
  // Initialize the TikTok Analytics Object if it does not exist
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  w.TiktokAnalyticsObject = 'ttq';
  const ttq = (w.ttq = w.ttq || []);
  ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie'
  ];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ttq.setAndDefer = function (t: any, e: string) {
    // eslint-disable-next-line security/detect-object-injection
    t[e] = function () {
      // eslint-disable-next-line prefer-rest-params
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < ttq.methods.length; i++) {
    // eslint-disable-next-line security/detect-object-injection
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }
  ttq.instance = function (t: string) {
    // eslint-disable-next-line security/detect-object-injection
    const e = ttq._i[t] || [];
    for (let n = 0; n < ttq.methods.length; n++) {
      // eslint-disable-next-line security/detect-object-injection
      ttq.setAndDefer(e, ttq.methods[n]);
    }
    return e;
  };
  // @ts-ignore
  window.ttq.load =
    // @ts-ignore
    window.ttq.load ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e: string, n: any) {
      const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      // @ts-ignore
      window.ttq._i = window.ttq._i || {};
      // @ts-ignore
      // eslint-disable-next-line security/detect-object-injection
      window.ttq._i[e] = [];
      // @ts-ignore
      // eslint-disable-next-line security/detect-object-injection
      window.ttq._i[e]._u = i;
      // @ts-ignore
      window.ttq._t = window.ttq._t || {};
      // @ts-ignore
      // eslint-disable-next-line security/detect-object-injection
      window.ttq._t[e] = +new Date();
      // @ts-ignore
      window.ttq._o = window.ttq._o || {};
      // @ts-ignore
      // eslint-disable-next-line security/detect-object-injection
      window.ttq._o[e] = n || {};
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = i + '?sdkid=' + e + '&lib=ttq';
      const firstScript = document.getElementsByTagName('script')[0];
      // @ts-ignore
      firstScript.parentNode.insertBefore(script, firstScript);
    };

  return true;
};
